<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('floor_assignment')">
            <app-default-button
                :title="$fieldTitle('add', 'floor_assignment', true)"
                v-if="$can('create_hotel_floor_assignment')"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="hotel-floor-assignment-table"
            :options="options"
            @action="triggerActions"
            @getFilteredValues="getFilterValues"
        />

        <app-hotel-floor-assignment-create
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-hotel-floor-assignment-reassign
            v-if="isReassignModalActive"
            v-model="isReassignModalActive"
            :assignment="selectedAssignment"
            @close="isReassignModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('hotel-floor-assignment-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import HotelFloorAssignmentMixins from "../../../Mixins/HotelFloorAssignmentMixins";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";

export default {
    name  : "AppHotelFloorAssignment",
    mixins: [HelperMixin, HotelFloorAssignmentMixins],
    data() {
        return {
            isModalActive         : false,
            isReassignModalActive : false,
            selectedUrl           : '',
            selectedAssignment    : null,
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${TENANT_BASE_URL}app/hotel/floor-assignment/${row.id}`;
                this.isModalActive = true;
            } else if (action.title === this.$t('reassign')) {
                this.selectedAssignment    = row;
                this.isReassignModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
    }
}
</script>
